import { render } from "./MoreCompetitions.vue?vue&type=template&id=445a0bcc&scoped=true"
import script from "./MoreCompetitions.vue?vue&type=script&lang=js"
export * from "./MoreCompetitions.vue?vue&type=script&lang=js"

import "./MoreCompetitions.vue?vue&type=style&index=0&id=445a0bcc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-445a0bcc"]])

export default __exports__